import React from "react";
import { Box, Divider, Spacer, Stack } from "digiwash-components";
import { ScrollView } from "react-native";

function SkeletonTimesheet() {
  let loadingDaysArray = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  let loadingTimesArray = [1, 2, 3, 4];

  return (
    <Box style={{ width: "100%" }}>
      <Box
        style={{
          borderWidth: 2,
          borderColor: "#EBF8FA",
          borderStyle: "solid",
          position: "absolute",
          width: "100%",
          top: -65,
        }}
        key="ScrollContainer"
        bg="common.white"
        br="m"
        py="xm"
        px="m"
      >
        <ScrollView
          contentContainerStyle={{
            flexGrow: 1,
          }}
          horizontal
          showsHorizontalScrollIndicator={false}
          key="Scrolling"
          style={{
            ...{
              flexGrow: 1,
            },
          }}
        >
          <Box
            style={{
              flexGrow: 1,
              flexDirection: "row-reverse",
              justifyContent: "space-between",
            }}
          >
            {loadingDaysArray.map(() => {
              return (
                <>
                  <Box
                    bg="neutrals.250"
                    br="s"
                    style={{ width: 64, height: 64 }}
                  >
                    <Stack distribution="center" direction="vertical" pt="xm">
                      <Box
                        bg="common.white"
                        br="s"
                        style={{ width: 48, height: 8 }}
                      />
                      <Divider size="xm" />
                      <Box
                        bg="common.white"
                        br="s"
                        style={{ width: 32, height: 16 }}
                      />
                    </Stack>
                  </Box>
                  <Spacer size="m" />
                </>
              );
            })}
          </Box>
        </ScrollView>
      </Box>
      <Divider size="xxxl" />
      <Box>
        <>
          <Divider size="m" />
          {loadingTimesArray.map(() => {
            return (
              <>
                <Box
                  br="xm"
                  p="l"
                  bg="neutrals.250"
                  style={{ width: "100%", height: 56 }}
                >
                  <Stack distribution="space-between">
                    <Stack>
                      <Box
                        bg="common.white"
                        br="s"
                        style={{
                          width: 24,
                          height: 24,
                        }}
                      />
                      <Spacer size="l" />
                      <Box
                        bg="common.white"
                        br="s"
                        style={{
                          width: 115,
                          height: 16,
                        }}
                      />
                    </Stack>
                    <Box
                      bg="common.white"
                      br="s"
                      style={{
                        width: 83,
                        height: 16,
                      }}
                    />
                  </Stack>
                </Box>
                <Divider size="l" />
              </>
            );
          })}
        </>
      </Box>
    </Box>
  );
}

export default SkeletonTimesheet;
